import { Meter } from "@bfc-software/pallet";

import { formatPercent, scanTone } from "../-data/format";

type Props = {
  /** A percentage already (95.28), or null for nothing to scan yet. */
  value: number | null | undefined;
  lang: string;
  /** What to show when there is no rate: nothing scanned is not 0%. */
  none: string;
};

/** A scan rate as its percentage over a bar coloured by how good it is. */
export function ScanBar({ value, lang, none }: Props) {
  const label = formatPercent(value, lang);
  if (label === undefined) return <>{none}</>;
  return (
    <Meter
      done={value ?? 0}
      total={100}
      label={label}
      tone={scanTone(value ?? 0)}
    />
  );
}
